import { useLocation, useParams } from "react-router-dom";
import "./CadastroUnits.css";
import { useEffect, useState } from "react";
import FormUnits from "../FormUnits/FormUnits";
import UnitsConfigsService from "../../../services/UnitsConfigsService";
import { useUserStore } from "../../../contexts/userStore";
import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import CondominioService from "../../../services/CondominioService";
import TagService from "../../../services/TagService";

const CadastroUnits = () => {
	const { unitId, tagExternalId } = useParams();
	const { state } = useLocation();
	const [type, setType] = useState("");
	const [unitsConfigs, setUnitsConfigs] = useState([]);
	const { selectedCondominio } = useUserStore();
	const [unit, setUnit] = useState(state);
	const [tag, setTag] = useState(null);

	async function fetchTag(externalId) {
		try {
			const response = await TagService.getTag(externalId);
			if (response.status === 200) {
				setTag(response.data);
			}
		} catch (error) {
			console.error("Error fetching tag:", error);
		}
	}

	const getUnitsConfigs = async (selectedCondominio) => {
		const response =
			await UnitsConfigsService.getCondominiumUnitsConfigs(selectedCondominio);
		setUnitsConfigs(response.data);
	};

	useEffect(() => {
		getUnitsConfigs(selectedCondominio);
	}, [selectedCondominio]);

	async function loadUnit(id) {
		const response = await CondominioService.getOne(id);
		if (response.data) {
			setUnit(response.data);
		}
	}

	useEffect(() => {
		if (tagExternalId) {
			fetchTag(tagExternalId);
		}
		setType(unitId || state ? "edicao" : "cadastro");

		if (unit) {
			setUnit(state);
			return;
		}

		if (unitId) {
			loadUnit(unitId);
		}
	}, [state, unitId]);

	return (
		<CadastroContainer>
			<FormUnits tag={tag} unit={unit} type={type} />
		</CadastroContainer>
	);
};

export default CadastroUnits;
